import { useMemo } from "react";
import { useIntercom } from "react-use-intercom";

import { Button } from "common/components/ui/Button";
import ProfileImage from "common/components/ui/ProfileImage";
import { Tag } from "common/components/ui/Tag";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import RentedIcon from "assets/icons/rented.svg?react";

export default function PendingRentedAccounts() {
  const isDesktop = useTwBreakpoint("lg");
  const { show } = useIntercom();
  const { rental_subscription, accounts } = useSelectedWorkspaceContext();

  const rentedAccounts = useMemo(
    () => accounts.filter(({ type }) => type === "rental"),
    [accounts],
  );

  if (!rental_subscription || rental_subscription.status === "cancelled") {
    return null;
  }

  const pendingAccountsCount = Math.max(
    0,
    rental_subscription.rented_count - rentedAccounts.length,
  );

  if (pendingAccountsCount === 0) return null;

  return (
    <aside className="border items-center flex flex-col lg:flex-row gap-1.5 lg:gap-2.5 border-black-200 rounded-5xl p-2 lg:px-4 lg:py-3 shadow-md">
      <div className="flex w-full items-start gap-x-1.5 lg:gap-x-2.5">
        <div className="flex shrink-0 -space-x-6 lg:-space-x-7">
          <div className="bg-black-50 size-8 lg:size-10 rounded-full border border-dashed border-black-200" />
          <div className="bg-black-50 size-8 lg:size-10 rounded-full border border-dashed border-black-300" />

          <div className="relative">
            <ProfileImage
              src=""
              size={isDesktop ? "md" : "sm"}
              className="border border-dashed border-black-400"
            />

            <RentedIcon className="absolute right-0 bottom-0" />
          </div>
        </div>

        <div className="flex flex-col items-start lg:gap-y-1">
          <div className="flex items-center gap-x-1.5">
            <h3 className="text-xs-bold lg:text-md-bold">Outreach Avatars</h3>
            <Tag variant="secondary" size="sm">
              {pendingAccountsCount} account
              {pendingAccountsCount > 1 ? "s" : ""}
            </Tag>
          </div>
          <p className="text-button-xxs lg:text-xs-medium text-black-500">
            Our team is warming up your Outreach Avatars, they will be added to
            your account shortly
          </p>
        </div>
      </div>

      <Button
        onClick={show}
        size="sm"
        variant="secondary-black"
        className="ml-auto"
      >
        Contact support
      </Button>
    </aside>
  );
}
